export const DIFF_CONTAINER_CLASS = "diffContainer"
